import DashboardOffers from './DashboardOffers';

export default DashboardOffers;
